export const bandNames = {
  2: "Vegetation Cover",
  3: "Soil Moisture",
  4: "Leaf N",
  6: "Actual ET",
  7: "Total Crop Growth",
  8: "Daily Crop Growth",
  9: "Soil Water Potential",
  10: "Soil Moisture Status",
  12: "Soil Temp Daily",
};

// Color codes for the legend
export const legendColors = [
  "#5E4FA2",
  "#67C2A5",
  "#E6F599",
  "#FEDF8A",
  "#F36C43",
  "#9E0142",
];

//Units for legends
export const legendUnits = {
  2: "",
  3: "m³/m³ or VMC(%)",
  4: "%",
  6: "mm/day",
  7: "kg/ha",
  8: "kg/ha/d",
  9: "cm or hPa (log10 scale)",
  12: "℃",
};

export const band10Colors = [
  "#B29609",
  "#1C07F8",
  "#49801B",
  "#ED7014",
  "#D91B14",
];

//Order in which the bands is rendered
export const orderedBandIds = [10, 2, 3, 4, 6, 7, 8, 9, 12];

export const AmCropGrowthLegendDetails = [
  {
    range: "0.66-1.0",
    label: "Good",
    minColor: "#1f7a1f",
    maxColor: "#004d00",
    description: "Healthy vegetation",
  },
  {
    range: "0.33-0.66",
    label: "Average",
    minColor: "#98da97",
    maxColor: "#228b22",
    description: "Moderate growth",
  },
  {
    range: "0.1-0.33",
    label: "Poor",
    minColor: "#ffffe0",
    maxColor: "#a8e6a3",
    description: "Stressed vegetation",
  },
];

export const AmSoilMoistureLegendDetails = [
  {
    range: "0.66-1.0",
    label: "Good",
    minColor: "#1f7a1f",
    maxColor: "#004d00",
    description: "High moisture content",
  },
  {
    range: "0.33-0.66",
    label: "Average",
    minColor: "#98da97",
    maxColor: "#228b22",
    description: "Average moisture",
  },
  {
    range: "0.1-0.33",
    label: "Poor",
    minColor: "#ffffe0",
    maxColor: "#a8e6a3",
    description: "Dry conditions",
  },
];
